import { IState } from '../../../redux/reducer/index';
import { O2OCommonContainer } from '../../../common/container/O2OContainer';
import { getUserTokens, logoutById } from '../ConsoleUsersAction';
import { bindActionCreators } from 'redux';
import { UserTokenComponentV2 } from './UserTokenComponentV2';

function mapStateToProps(rootState: IState) {
  return {
    userTokens: rootState.userTokens,
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    getUserTokens: bindActionCreators(getUserTokens, dispatch),
    logoutById: bindActionCreators(logoutById, dispatch),
  };
}

export const UserTokenContainer = O2OCommonContainer(UserTokenComponentV2, mapStateToProps, mapDispatchToProps);
